import { HOME_ROUTE } from "_constants";
import { useMainStore } from "./store/useMainStore";
import { useEffect, useRef, useState } from "react";
import { useCustomerManagementStore } from "./store";
import { useNavigate } from "react-router-dom";
import { getOnboardingStepRoute, ONBOARDING_BLOCKED } from "_helpers";
import { Modal, Typography } from "antd";

export const useSigninSuccess = () => {
  const {
    customerManagement: {
      signInStatus,
      onboardingStatus,
      onboardingStatusDetails,
      user,
    },
    clearSignInStatus,
    fetchOnboardingStatus,
    clearOnboardingStatus,
    logout,
  } = useCustomerManagementStore();
  const {
    main: { redirectPath },
    setOnboardingCheckPending,
  } = useMainStore();
  const navigate = useNavigate();
  const [shouldRouteAfterSignin, setShouldRouteAfterSignin] = useState(false);
  const blockedModalOpenRef = useRef(false);

  useEffect(() => {
    if (signInStatus === "success") {
      setOnboardingCheckPending(true);
      setShouldRouteAfterSignin(true);
      fetchOnboardingStatus();
    }
  }, [fetchOnboardingStatus, setOnboardingCheckPending, signInStatus]);

  useEffect(() => {
    if (!shouldRouteAfterSignin) return;

    if (onboardingStatus === "error") {
      setOnboardingCheckPending(false);
      clearSignInStatus();
      clearOnboardingStatus();
      setShouldRouteAfterSignin(false);
      navigate(redirectPath || HOME_ROUTE, { replace: true });
      return;
    }

    if (onboardingStatus !== "success") return;

    setOnboardingCheckPending(false);
    clearSignInStatus();
    clearOnboardingStatus();
    setShouldRouteAfterSignin(false);

    const onboardingRoute = getOnboardingStepRoute(onboardingStatusDetails);

    if (onboardingRoute === ONBOARDING_BLOCKED) {
      if (blockedModalOpenRef.current) return;
      blockedModalOpenRef.current = true;
      const userEmail = user?.email || onboardingStatusDetails?.email || "";
      const handleClose = () => {
        blockedModalOpenRef.current = false;
        setOnboardingCheckPending(false);
        logout();
      };
      Modal.error({
        title: "Account Blocked",
        content: (
          <Typography.Text>
            {userEmail && (
              <>
                The account <Typography.Text strong>{userEmail}</Typography.Text> has been blocked.
              </>
            )}
            {!userEmail && "Your account has been blocked."}
            {" "}Please contact our support team for assistance.
            <br /><br />
            <Typography.Text strong>Phone: </Typography.Text>
            <Typography.Link href="tel:+254793333333">+254 793 333 333</Typography.Link>
            <br />
            <Typography.Text strong>Email: </Typography.Text>
            <Typography.Link href="mailto:support@empirefx.com">support@empirefx.com</Typography.Link>
          </Typography.Text>
        ),
        okText: "OK",
        centered: true,
        onOk: handleClose,
        onCancel: handleClose,
      });
      return;
    }

    const destination =
      onboardingRoute === HOME_ROUTE ? redirectPath || HOME_ROUTE : onboardingRoute;
    navigate(destination, { replace: true });
  }, [
    clearOnboardingStatus,
    clearSignInStatus,
    logout,
    navigate,
    onboardingStatus,
    onboardingStatusDetails,
    redirectPath,
    setOnboardingCheckPending,
    shouldRouteAfterSignin,
    user?.email,
  ]);
};
